<script setup>
const props = defineProps({
	icon: {
		type: String,
		required: true,
	},
})
</script>

<template>
	<div class="flex items-center justify-center gap-2 rounded-md border-[1.5px] border-white/10 px-2 py-1 text-white/70">
		<i class="text-sm" :class="icon" />
		<p class="mt-0.5 text-sm"><slot /></p>
	</div>
</template>
